import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AiOutlineClose } from 'react-icons/ai';

export const InfoModal = ({ isOpen, onClose, title, children }) => {
  // Close modal on ESC key press
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{ zIndex: 9999 }}
      onClick={onClose}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm"
        style={{
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)'
        }}
      />

      {/* Modal Content */}
      <div
        className="relative bg-white/95 rounded-2xl shadow-2xl border border-gray-200/60 max-w-3xl w-full max-h-[80vh] overflow-y-auto backdrop-blur-xl"
        style={{
          backdropFilter: 'blur(40px) saturate(180%)',
          WebkitBackdropFilter: 'blur(40px) saturate(180%)',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2), 0 8px 24px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.5)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-start p-5 border-b border-gray-200/60">
          <h3 className="text-xl font-semibold text-gray-900">
            {title}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-900 transition-colors p-1 hover:bg-gray-100 rounded-lg"
            aria-label="Close modal"
          >
            <AiOutlineClose className="text-xl" />
          </button>
        </div>

        {/* Content */}
        <div className="p-5 text-gray-700">
          {children}
        </div>

        {/* Footer */}
        <div className="flex justify-end p-5 border-t border-gray-200/60">
          <button
            onClick={onClose}
            className="text-white bg-gray-900 hover:bg-gray-800 focus:ring-2 focus:outline-none focus:ring-gray-400 font-semibold rounded-xl text-sm px-5 py-2.5 text-center transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Sluiten
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
